import i18n from 'i18next';

import { onboardingTranslations } from './index';

/**
 * Registers onboarding domain translations into i18next.
 * Called once at app bootstrap.
 */
export const registerOnboardingTranslations = (): void => {
  if (!i18n.addResourceBundle) return;

  Object.entries(onboardingTranslations).forEach(([language, resources]) => {
    i18n.addResourceBundle(language, 'onboarding', resources, true, true);
  });
};

/**
 * Checks if onboarding translations are loaded.
 *
 * @param language - Language to check (defaults to current i18n language)
 * @returns True if translations are loaded
 */
export const areOnboardingTranslationsLoaded = (language?: string): boolean => {
  if (!i18n.hasResourceBundle) return false;

  const lng = language || i18n.language;
  return i18n.hasResourceBundle(lng, 'onboarding');
};
